import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { LocationDocument } from '../Locations/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  PredictionDocument,
  predictionPullModifier,
  predictionPullQueryBuilder,
  predictionPushQueryBuilder,
} from './queryBuilder';

export function borerShiftPredictionFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember<BorerShiftDocument>,
  locations: FamilyMember<LocationDocument>,
): FamilyMember<PredictionDocument> {
  const syncConfig = configBuilder<PredictionDocument>(RxdbCollectionNameV2.BORER_SHIFT_PREDICTION);
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, predictionPullQueryBuilder);
  pullConfig.modifier = predictionPullModifier;

  push(syncConfig, predictionPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_PREDICTION, replicationState, [
    borerShift,
    locations,
  ]);
}
